module.exports = __webpack_public_path__ + "components/home-header/static/header-5--small-066e5650de3e5038f01ea26a4a7c41ae.jpg";